(() => {
  /**
   * @ngdoc directive
   * @name kareo.ui.shared.assets:kDailyTrackedImpression
   * @restrict E
   * @scope
   * @description
   * Implementation of k-tracked-impression with a preset value for max-last-occurrence.
   * Renders transcluded children if the user has not seen the tracking key today.
   * Records a user impression of the tracking key when shown.
   *
   * @param {string} trackingKey Unique key to track impressions of this component.
   */

  const maxLastOccurrence = moment().startOf('day');

  angular
    .module('kareo.ui.shared.directives.k-daily-tracked-impression', [
      'kareo.ui.shared.directives.k-tracked-impression'
    ])
    .component('kDailyTrackedImpression', {
      controller,
      controllerAs: 'vm',
      bindings: {
        trackingKey: '@'
      },
      template: require('./k-daily-tracked-impression.pug')(),
      transclude: true
    });

  function controller() {
    const vm = this;

    vm.maxLastOccurrence = maxLastOccurrence;
  }
})();
